export const CHECK_CATEGORIES = [
  {
    key: "FA",
    shortLabel: "FA",
    fullLabel: "Fully Automated",
    title: "Fully Automated",
    description: (
      <>
        This check is <b>fully automated</b>. If the check status is not
        updated, please ensure the relevant set up procedures are completed.
      </>
    ),
  },
  {
    key: "PA",
    shortLabel: "PA",
    fullLabel: "Partially Automated",
    title: "Partially Automated",
    description: (
      <>
        This check is <b>partially automated</b>. In order to update the check
        status, you need to <b>upload relevant evidence</b>. Once the evidence
        is uploaded, system will automatically validate the evidence and update
        check status.
      </>
    ),
  },
  {
    key: "NA",
    shortLabel: "NA",
    fullLabel: "Not Automated",
    title: "Not Automated",
    description: (
      <>
        This check is currently <b>not automated</b>. In order to update the
        check status to <b>Pass</b>, you need to go to the{" "}
        <b>Create exception</b> tab, select <b>override check status</b> and
        upload relevant evidence with an explanation.
      </>
    ),
  },
];
